<div class="title">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.TITLE' | translate }}
</div>
<div class="subtitle">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.DESCRIPTION' | translate }}
</div>

<div class="settings">
  <meeting-scheduler-integration-selection
    [initialSelection]="initialServiceSelection$ | async"
    (integrationSelected)="onIntegrationSelected($event)"
  ></meeting-scheduler-integration-selection>
  <ng-container *ngIf="selection$ | async as selection">
    <ng-container *ngIf="!selection.isConnected">
      <div class="meeting-app-actions">
        <ng-container *ngIf="selection.service === zoom">
          <meeting-scheduler-connect-with-zoom-button [serviceKey]="serviceKey" [isMeetingApp]="true">
          </meeting-scheduler-connect-with-zoom-button>
        </ng-container>
        <ng-container *ngIf="selection.service === meet">
          <meeting-scheduler-connect-with-google-button
            [serviceKey]="serviceKey"
            [isMeetingApp]="true"
          ></meeting-scheduler-connect-with-google-button>
        </ng-container>
        <ng-container *ngIf="selection.service === microsoft">
          <meeting-scheduler-connect-with-microsoft-button
            [serviceKey]="serviceKey"
            [isMeetingApp]="true"
          ></meeting-scheduler-connect-with-microsoft-button>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="selection.isConnected">
      <ng-content></ng-content>
    </ng-container>
  </ng-container>
</div>
